import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Matter} from "common/types/matter";

interface MatterDeleteDialogProps {
  matter: Matter | null;
  onConfirm: () => void;
  onCancel: () => void;
}

function MatterDeleteDialog({
  matter,
  onConfirm,
  onCancel,
}: MatterDeleteDialogProps) {
  return (
    <Dialog open={Boolean(matter)} onClose={onCancel}>
      <DialogTitle>Delete Contractual Framework</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this contractual framework? This will
          permanently delete the contractual framework and all associated
          documents. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary" autoFocus>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MatterDeleteDialog;
